import { render } from "./FeaturedProduct.vue?vue&type=template&id=7b146dc6"
import script from "./FeaturedProduct.vue?vue&type=script&lang=js"
export * from "./FeaturedProduct.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TechLHAB\\OneDrive\\Desktop\\WEBAPPS\\VueJs\\ecommerce-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__